import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    position: 'relative',
    backgroundImage: 'url(/static/images/bgpinpeo.svg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
  mainContent: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 80px)',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      minHeight: 'calc(100vh - 100px)',
      padding: theme.spacing(1),
    },
  },
  pageContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  contentCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '438px',
    marginRight: 'auto',
    marginLeft: 'auto',
  },
  footer: {
    width: '100%',
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    zIndex: 10,
    backgroundColor: 'transparent',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      padding: '15px 0',
    },
  },
  footerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: '1200px',
    padding: '0 24px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '10px',
      textAlign: 'center',
    },
  },
  versionText: {
    color: '#727272',
    fontSize: '0.9rem',
    fontWeight: '500',
  },
  linksContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '25px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '10px',
    },
  },
  footerLink: {
    color: '#727272',
    textDecoration: 'none',
    fontSize: '0.9rem',
    fontWeight: '500',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export default useStyles;
